<template>
	<div class="pa-2">
		<h5>ORDEN DE TRABAJO TEMPORAL</h5>
		<v-select
			v-model="place"
			:items="places"
			item-text="name"
			item-value="_id"
			label="Seleccione un establecimiento"
			no-data-text="No hay establecimientos "
			dense
			filled
			outlined
			persistent-hint
			hint="Selecione el lugar donde creará la OT temeporal"
			class="mr-2 my-2"
			style="max-width: 250px"
		></v-select>
		<v-btn
			:disabled="!lodgingSelect || !place"
			small
			class="ma-2"
			color="accent"
			to="/nueva-orden-de-trabajo-mobile/rrplagas"
			>Crear OT temporal</v-btn
		>
	</div>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapMutations, mapActions } from 'vuex';
export default {
	name: 'temporalOTs',
	props: {
		places: {
			required: true,
		},
		person: {
			required: true,
		},
	},
	data() {
		return {
			place: null,
			lodTempOK: false,
		};
	},
	computed: {
		placesSort() {
			let places = this.lodgingsOfPerson.filter(place => {
				let filter1 = true;
				if (this.filter1) {
					filter1 = place.name.toLowerCase().indexOf(this.filter1.toLowerCase()) > -1;
				}
				if (this.selectedDay) {
					filter1 = this.filterLodgings(place).length !== 0;
				}
				return filter1;
			});
			return places;
		},
		...mapGetters({
			listPerson: 'Person/persons',
			lodgingsOfPerson: 'Lodging/lodgingsOfPerson',
			lodgingSelect: 'Lodging/lodgingSelect',
		}),
	},
	watch: {
		place(newVal) {
			let start = moment().format('YYYY-MM-DD');
			let end = moment().format('YYYY-MM-DD');
			let place = null;
			if (this.placesSort) place = this.placesSort.find(item => item._id == newVal);
			if (place) {
				this.lodTempOK = {
					start,
					end,
					place,
					person: this.person,
					room: 'Sin etiqueta',
					group: 'Sin periodo',
				};
				this.setLod();
			}
		},
	},
	methods: {
		setLod() {
			this.setPerson(this.lodTempOK.person);
			this.setLodgingSelect({
				start: this.lodTempOK.start,
				end: this.lodTempOK.end,
				place: this.lodTempOK.place,
				person: this.lodTempOK.person,
				room: this.lodTempOK.room,
				group: this.lodTempOK.group,
				_id: this.lodTempOK.place._id + '-' + 'tempOT',
			});
			this.$emit('defaultForm');
		},
		...mapMutations({
			setLodgingSelect: 'Lodging/setLodgingSelect',
			setLodgingForm: 'Lodging/setLodgingForm',
			setPerson: 'Person/setPerson',
		}),
		...mapActions({
			deleteWorkerVisit: 'Lodging/deleteWorkerVisit',
		}),
	},
};
</script>
